import { _GetFieldList, getDisplayValue } from "../../table/helpers"
import {
  FieldIsFocused,
  FieldIsValid,
  FieldListModeType,
  FieldSetVal,
  SYSField,
} from "../fieldapi"
import {
  _FieldListBustCache,
  _setFieldFocus,
  _setFieldTouched,
  _setFieldWatched,
} from "../helper"
import { FilterHitList, GetRowFromFormState } from "./helpers"
import { SYSControlBase } from "./syscontrolbase"

import { disableBodyScroll, enableBodyScroll } from "../../../global/globals"
import type { HookFieldGetList_ReturnType } from "../../../global/hooks"
import { HookFieldGetList } from "../../../global/hooks"
import { ProcessIsRunning } from "../../longrunningprocesstracker/processapi"

import { html, ifDefined, SYSForm, TemplateResult } from "../../.."
import { DialogClose, DialogIsOpen, DialogOpen } from "../../dialog/dialogapi"
import { FormGet } from "../formapi"

import { FocusSet, SYSSeqId } from "../../../global/globalapi"
import { OptionsValidateResultError } from "../validators"

export type ListControlPart = "Search" | "LocalList" | "Input" | "Other"

export type ListState = {
  serverEndpoint?: string

  lookupDefKey?: string
  displayField?: string
  valueField: string
  filterField?: string
  displayValueField?: boolean

  refreshMode?: FieldListModeType

  showCachedHitsWhileTyping?: boolean

  acceptOnlyListValues?: boolean

  //introduced because we sometimes don't want a filter when allowing all input and clicking on  listpopup button (casic qorquickorder positionen preisauswahl)
  acceptNotOnlyListValuesIgnoreFilter?: boolean

  acceptOnlyListValuesValidatorOptions?: OptionsValidateResultError
  //acceptEmpty?: boolean
  tryGetLookupFromServerInFormInitIfNotFound?: boolean
  tryGetLookupFromServerInFormInitIfNotFoundIgnoreValues?: "None" | any[]
  /*autoRefreshFromServerAlwaysInInit?: boolean*/
  mode?: "List" | "Select" | "Option"
  selectOnly?: boolean
  filterValue?: any

  onlyRefreshFromServerIfOlderThanMs?: number
  showRefreshFromServerSnack?: boolean
  _state?: {
    lastRefreshTimestamp?: number
    needsRefresh: boolean
    lastPostParams: string
    //needsListValidationOnFirstDisplay?: boolean
  }
}

const _debounce = 40
export class SYSListControl extends SYSControlBase {
  localList: TemplateResult
  localListState: typeof this.state.ovl.libState.localHitListState
  hitListDialogBody: TemplateResult
  hitListDialogFooter: TemplateResult
  directHit: { value: any; description: any }
  listPopupDebouncer: any
  debouncer: any
  wasKey: boolean

  async init() {
    this.localListState = this.state.ovl.libState.localHitListState
    this.directHit = {
      value: undefined,
      description: undefined,
    }
    await super.init()
    _FieldListBustCache(this.field)
  }

  handleCancel = (e: Event) => {
    this.actions.ovl.dialog._DialogClose("SYSHitListDialog")
  }

  async handleListPopupHelper(e: Event) {
    let explicit = true
    if (
      !this.field.list.acceptOnlyListValues &&
      !this.field.list.acceptNotOnlyListValuesIgnoreFilter
    ) {
      explicit = false
      this.field.list.filterValue = this.inputElement.value
    }
    await this.handleListPopup(e, explicit)
  }

  async handleListPopup(e: Event, explicit: boolean = false) {
    if (this.listPopupDebouncer) {
      clearTimeout(this.listPopupDebouncer)
    }
    this.listPopupDebouncer = setTimeout(async () => {
      if (DialogIsOpen("SYSHitListDialog")) {
        return
      }

      if (e) {
        e.stopPropagation()
      }
      this.forceCloseLocalHitList()

      let filterValue = ""

      if (!explicit) {
        filterValue = this.field.list.filterValue
      } else {
        this.field.list.filterValue = ""
      }
      if (
        this.field.list.mode !== "Select" &&
        this.field.list.mode !== "Option" &&
        this.field.list.serverEndpoint &&
        !ProcessIsRunning("SYSGetLookupData")
      ) {
        await this.actions.ovl.internal._FillListControl({
          list: this.field.list,
          filterValue,
          columnKey: this.field.fieldKey,
          row: GetRowFromFormState(this.formState),
          feature: this.formState.feature,
          formState: this.formState,
        })
        let filterRes = FilterHitList(
          this.field.list,
          filterValue,
          this.formState,
          this.field.fieldKey,
          undefined,
          true
        )
        if (!explicit && filterRes.directValue !== undefined) {
          this.selectedCallback(filterRes.directValue)
          return
        }
      }

      this.state.ovl.libState.hitListDialogState = {
        fieldKey: this.field.fieldKey,
        formType: this.field.formType,
        formId: this.field.formId,
        selectedCallback: this.selectedCallback,
      }
      DialogOpen("SYSHitListDialog")
    }, _debounce + 100)
  }

  selectedCallback = async (selectedKey: string) => {
    let field = this.field
    await DialogClose("SYSHitListDialog")
    if (selectedKey === "@@ovlcanceled") {
      FocusSet(this.inputElement.id)
      return
    } else {
      let dataList: HookFieldGetList_ReturnType = _GetFieldList(
        this.actions.app.features[this.formState.feature].hooks[
          HookFieldGetList.replace(
            "{subFeature}",
            this.formState.subFeature
          ).replace("{fieldKey}", field.fieldKey)
        ],
        field.fieldKey,
        this.formState,
        this.formState?.tableDefId
      )
      let writeBackValue
      if (dataList.data[selectedKey][field.list.valueField] !== undefined) {
        writeBackValue = dataList.data[selectedKey][field.list.valueField]
      } else {
        writeBackValue = selectedKey
      }
      await FieldSetVal(this.field, writeBackValue, {
        watched: true,
        userTriggered: true,
      })
    }
    this.forceCloseLocalHitList()
  }

  handleGotFocusSearch(e: Event) {
    this.forceCloseLocalHitList()
    //    if (this.field.list.mode !== "Select") {
    _setFieldFocus(this.field, true)
    //    }
  }

  handleFocus(e: Event) {
    e.stopPropagation()
    _setFieldFocus(this.field, true)

    if (this.localList) {
      this.forceCloseLocalHitList()
    }
  }

  async FieldSetValueAndCheckFocus(
    field: SYSField,
    value,
    setWatched: boolean = false
  ) {
    await FieldSetVal(field, value, {
      watched: setWatched === true ? true : undefined,
      userTriggered: true,
    })
    // if value gets forced here and there is eg. a valuechanged hook which sets focus to different field
    // then we need to reset fieldfocus and close eventually list
    if (
      document.activeElement &&
      document.activeElement.id.indexOf(field.id) < 0
    ) {
      _setFieldFocus(field, false)
      this.forceCloseLocalHitList()
    }
  }
  handleFocusOut = async (e: Event) => {
    // in focus out following things need to be checked:
    // - did the user enter a value (field needs to be touched) that should be used to filter the list? -> open popup filtered
    // - did the user enter a value (field needs to be touched) that doesn't exist and we are in select mode (no db lookup) -> open popup not filtered
    // - did the user enter a value (field needs to be touched) which is unique and we are in select mode -> directly use that value
    // - did the user leave the field (well the formcontrol div to be exact) without having it touched -> do nothing

    // if popup opens depends on List Validator. if the list is invalid popup opens elsewise not

    // to check if we are operating inside the formcontrol div we need to do a few checks.
    // this code is tested on ios safari and chrome android as well
    // there we have some keys on the keyboard like "go on to next field" which does not open the popup but thats fine

    //@ts-ignore
    let toControlId = e.relatedTarget ? e.relatedTarget.id : ""
    let toControlType: ListControlPart
    if (toControlId.indexOf("ovlhl_") > -1) {
      toControlType = "LocalList"
    } else if (toControlId.indexOf("search") > -1) {
      toControlType = "Search"
    } else if (toControlId !== "") {
      toControlType = "Input"
    } else {
      toControlType = "Other"
    }

    let field = this.field
    let movedOut = false

    if (toControlType === "Other" || !toControlId.endsWith(field.id)) {
      movedOut = true
    }

    //do nothing if user just navigated into locallist or from locallist into current input or into list dialog
    if (
      toControlType === "LocalList" ||
      (!movedOut && toControlType === "Input") ||
      DialogIsOpen("SYSHitListDialog")
    ) {
      return
    }

    // if moving away then close locallist and set focus false
    if (movedOut) {
      if (field.touched) {
        if (await this.wasDirectSelectHit()) {
          this.forceCloseLocalHitList()
          _setFieldFocus(field, false)

          return
        }
        await FieldSetVal(field, field.value, { userTriggered: true })
      }
      this.forceCloseLocalHitList()

      _setFieldFocus(field, false)
      return
    }

    if (field.touched) {
      let valueToWriteBack = field.value
      if (await this.wasDirectSelectHit()) {
        return
      }
      await this.FieldSetValueAndCheckFocus(field, valueToWriteBack)
      if (field.list.acceptOnlyListValues) {
        if (
          this.field.validationResult.System.filter(
            (f) => f.translationKey === "SYSValidatorListValue"
          ).length > 0
        ) {
          this.field.list.filterValue = this.inputElement.value
          this.handleListPopup(e, false)
        }
      }
    }
  }
  wasDirectSelectHit = async () => {
    let field = this.field
    let valueToWriteBack = field.value
    if (this.directHit.value !== undefined) {
      if (this.field.list.mode === "Select" && valueToWriteBack) {
        if (
          this.field.list.acceptOnlyListValues ||
          valueToWriteBack ===
            this.directHit
              .value /* because of Test FrmList 04 ... Entering <null> should result in Db Null */ ||
          valueToWriteBack === this.directHit.description
        ) {
          /* because of Test FrmList 04 ... Entering <null> should result in Db Null */
          if (valueToWriteBack === this.directHit.description) {
            valueToWriteBack = this.directHit.value
          } else {
            valueToWriteBack = this.directHit.value
          }
          this.directHit.value = undefined
          await this.FieldSetValueAndCheckFocus(field, valueToWriteBack, true)
          return true
        }
      }
    }
    return false
  }
  handleSearchKeyUp(e: KeyboardEvent) {
    if (e.key === "ArrowDown" || e.key === "Enter") {
      e.stopPropagation()
      e.preventDefault()
      this.handleListPopupHelper(e)
    }
  }

  async handleInput(e: InputEvent) {
    let field = this.field
    let filterValue = this.inputElement.value
    // we need wasTouched becuase of autofill issues
    // if it for some reason gets autofilled it will be invalid
    // without that meaning that isinnerevent was false for a autofilled then list validation gets not called
    //let wasTouched = field.touched

    await this.actions.ovl.form._ChangeField({
      fieldKey: this.field.fieldKey,
      formState: this.formState,
      value: filterValue,
      isInnerEvent: true,
      watched: true,
      noRetrigger: true,
    })
    _setFieldTouched(field, true)
    if (filterValue === "") {
      this.forceCloseLocalHitList()
      return
    }
    // if (!wasTouched) {
    //   return
    // }
    disableBodyScroll(true)
    if (field.list.showCachedHitsWhileTyping && !field.list.selectOnly) {
      //let hl = document.getElementById("ovl-hitlist")
      field.list.filterValue = this.inputElement.value
      this.openLocalHitList()
    }
  }

  async handleKey(e: KeyboardEvent) {
    if (!e.key) {
      return
    }
    switch (e.key) {
      case "Enter":
        if (await this.wasDirectSelectHit()) {
          this.forceCloseLocalHitList()
          return
        }
        this.field.list.filterValue = this.inputElement.value
        this.handleListPopup(e, false)
        break
      case "ArrowDown":
        if (!this.field.list.showCachedHitsWhileTyping) {
          if (await this.wasDirectSelectHit()) {
            this.forceCloseLocalHitList()
            return
          }
          this.field.list.filterValue = this.inputElement.value
          this.handleListPopup(e, false)
        } else {
          if (!this.localList) {
            this.field.list.filterValue = ""
            this.openLocalHitList()
          }
          setTimeout(() => {
            if (this.localList) {
              // just focus inline list first value if there
              let focusEl = <HTMLElement>(
                document.getElementsByClassName("ovl-hitlist-row")[0]
              )
              if (focusEl) {
                focusEl.focus()
              }
            }
          }, 100)
        }
        break
      case "Escape":
        this.forceCloseLocalHitList()
        return
    }
  }
  async getUI() {
    let visible = super.InitControl()
    if (visible === false) {
      return undefined
    }

    if (!this.field) {
      return
    }
    let field = this.field
    // read this one so we can force rerenders by toggling it...
    field.list.filterValue
    let displayValue = field.value
    if (!(FieldIsFocused(field) && field.touched)) {
      let formState = FormGet(<SYSForm>field.formType, {
        instance: field.formId,
      }).formState

      if (formState && FieldIsValid(field)) {
        displayValue = getDisplayValue(
          field.fieldKey,
          { list: field.list, type: field.type, ui: field.ui },
          field.convertedValue,
          formState.feature,
          formState,
          formState?.tableDefId,
          field.list.displayField
        )
      }
    }
    if (displayValue === undefined) {
      displayValue = ""
    }
    let readOnly = this.getReadOnly()

    let icon = "search"
    if (field.list.mode === "Select") {
      icon = "arrow-bottom"
    }

    let control
    if (!field.list.selectOnly) {
      if (typeof displayValue === "object") {
        displayValue = field.convertedValue
      }
      control = html`
        <input
          tabindex=${ifDefined(!this.focusable ? "-1" : undefined)}
          placeholder=${ifDefined(
            this.field.ui.infoValue ? this.field.ui.infoValue : undefined
          )}
          autocomplete="one-time-code"
          aria-autocomplete="none"
          autocorrect="off"
          autocapitalize="off"
          name="search_ios_autocomplete_hack"
          spellcheck="false"
          type="text"
          class=${`${this.getEditorClass()} fd-input fd-input-group__input ovl-formcontrol-input ovl-value__${
            field.fieldKey
          } ${readOnly ? "ovl-disabled" : "ovl-focusable"} ${
            field.ui.selectIfFocused === true ? "ovl-focusselected" : ""
          }`}
          id=${field.id}
          value=${displayValue}
          .value=${displayValue}
          @keyup=${(e) => this.handleKey(e)}
          @input=${(e) => this.handleInput(e)}
          @focus=${(e) => this.handleFocus(e)}
          ?readonly=${readOnly}
          enterkeyhint="next"
        />
      `
    } else {
      // placeholder doen't wor on div
      // so we adjust displayvalue if its empty
      let placeholderclass
      if (!displayValue && this.field.ui.infoValue) {
        displayValue = this.field.ui.infoValue
        placeholderclass = "ovl-placeholder"
      }

      control = html` <div
        @mousedown=${(e) => {
          // left mouse button?
          if (e.which === 1) {
            this.handleListPopupHelper(e)
          }
        }}
        @focus=${(e) => this.handleFocus(e)}
        tabindex="-1"
        class=${`${this.getEditorClass()} ${placeholderclass} fd-input fd-input-group__input ovl-cursor-pointer ovl-formcontrol-selectdisplay ovl-value__${
          field.fieldKey
        } ${readOnly ? "ovl-disabled" : "ovl-focusable"} ${
          field.ui.selectIfFocused === true ? "ovl-focusselected" : ""
        }`}
        id=${field.id}
        value=${displayValue}
        .value=${displayValue}
      >
        ${displayValue}
      </div>`
    }

    return html`
      <div class="ovl-listcontrol-main">
        <div
          @focusout=${async (e) => {
            await this.handleFocusOut(e)
          }}
          class=${`fd-form-item ovl-formcontrol-container ovl-container-listbox ovl-container__${
            field.fieldKey
          } ${this.getEditorClass()} ${
            this.customInfo.customRowClassContainerName
          }`}
        >
          <ovl-controllabel .props=${() => this.field}> </ovl-controllabel>
          <div
            class=${`fd-input-group ovl-formcontrol-value ${this.getOutlineValidationHint()} ${
              this.customInfo.customRowClassName
            } __inpfocbox`}
          >
            ${control}
            <span
              tabindex=${!this.focusable ? "-1" : "0"}
              @mousedown=${(e) => {
                if (e.which === 1) {
                  this.handleListPopupHelper(e)
                }
              }}
              @keydown=${(e) => this.handleSearchKeyUp(e)}
              @focus=${(e) => this.handleGotFocusSearch(e)}
              id=${`search${field.id}`}
              class=${`${this.getEditorClass()} fd-input-group__addon sap-icon--${icon} ovl-formcontrol-input ovl-formcontrol-searchbutton ovl-formcontrol-searchbutton__${
                field.fieldKey
              } ${
                readOnly || ProcessIsRunning("SYSGetLookupData")
                  ? "ovl-disabled"
                  : ""
              }`}
              role="presentation"
            ></span>
          </div>

          ${this.localList}
          <ovl-controlcustomhint .props=${() => this.field}>
          </ovl-controlcustomhint>
          <ovl-controlvalidationhint .props=${() => this.field}>
          </ovl-controlvalidationhint>
        </div>
      </div>
    `
  }
  async afterRender() {
    this.inputElement = document.getElementById(this.field.id)
    await super.afterRender()
  }

  openLocalHitList() {
    let field = this.field
    this.localListState.open = true
    this.localList = html`
      <ovl-hitlist
        class="ovl_dlg_z_index_12"
        id="ovl-hitlist"
        .props=${(state) => {
          let listData: HookFieldGetList_ReturnType = _GetFieldList(
            this.actions.app.features[this.formState.feature].hooks[
              HookFieldGetList.replace(
                "{subFeature}",
                this.formState.subFeature
              ).replace("{fieldKey}", field.fieldKey)
            ],
            field.fieldKey,
            this.formState,
            this.formState?.tableDefId,
            true,
            false
          )
          return {
            selectedFieldKey: undefined,
            fieldId: field.id,
            list: field.list,
            listData,

            filteredKeys: undefined,
            type: "inline",
            animation: true,
            selectedCallback: this.selectedCallback,
            field,
            directHit: this.directHit,
          }
        }}
      ></ovl-hitlist>
    `
    this.doRender()
  }

  forceCloseLocalHitList() {
    if (this.localList) {
      this.localList = null
      this.localListState.open = false

      // this forces a rerender
      this.doRender()

      enableBodyScroll()
    }
  }
  async disconnectedCallback() {
    if (this.debouncer) {
      clearTimeout(this.debouncer)
      this.debouncer = null
    }
    if (this.updatedDebouncer) {
      clearTimeout(this.updatedDebouncer)
      this.updatedDebouncer = null
    }
    this.localList = null
    this.localListState.open = false
    this.selectedCallback = null
    await super.disconnectedCallback()
  }
}
